module.exports = __webpack_public_path__ + "static/media/10.868ff805.jpg";